import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Shots from "../components/Shots";
import ImageList from "../components/ImageList";
import request from "request";
import { apiUrl } from "../util";
class ScreenShots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenshots: null,
      landingPage: null,
      split: null,
    };
  }
  componentDidMount() {
    const { id, ctime, url } = this.props.match.params;
    if (url) {
      request(
        `${apiUrl}/getNewSemScreenShots?id=${id}&ctime=${ctime}`,
        (err, res, data) => {
          const json = JSON.parse(data);
          const split = json.screens.landingPages[decodeURIComponent(url)];
          let landingPage;
          let finalSplit;
          let totalCount = 0;
          if (split) {
            landingPage = split[Object.keys(split)[0]].url;
            Object.keys(split).forEach(s => (totalCount += split[s].count));
            let cnt = 1;
            if (split) {
              finalSplit = Object.keys(split).map(s => {
                const ss = split[s];
                ss.id = s;
                ss.src = ss.ss;
                ss.altText = "";
                ss.caption = `Variant ${cnt}, ${ss.count}, ${(
                  (ss.count / totalCount) *
                  100
                ).toFixed(0)}%`;
                cnt++;
                return ss;
              });
            }
          }
          this.setState({
            screenshots: json.screens,
            split: finalSplit,
            landingPage,
          });
        }
      );
      return;
    }
    request(
      `${apiUrl}/getNewSemAds?id=${id}&ctime=${ctime}`,
      (err, res, data) => {
        const json = JSON.parse(data);
        this.setState({
          screenshots: json.screens,
        });
      }
    );
  }
  getAllShots = (e, allShotsId) => {
    e.preventDefault();
    request(`${apiUrl}/getAdShots?id=${allShotsId}`, (err, res, data) => {
      const json = JSON.parse(data);
      const { screenshots } = this.state;
      const newScreenShots = {
        ctime: screenshots.ctime,
        id: screenshots.id,
        landingPages: screenshots.landingPages,
        runCount: screenshots.runCount,
        term: screenshots.term,
        data: {},
      };
      Object.keys(this.state.screenshots.data).forEach(d => {
        const item = this.state.screenshots.data[d];
        if (item.allShotsId === allShotsId) {
          item.shots = json.ads.shots.map(s => s.screenshot);
          item.gotAllShots = true;
        }
        newScreenShots.data[d] = item;
      });
      this.setState({
        screenshots: newScreenShots,
      });
    });
  };
  render() {
    const { ctime } = this.props.match.params;
    const { screenshots, split, landingPage } = this.state;
    const { user } = this.props;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (screenshots) {
      const ssData = screenshots.data
        ? screenshots.data
        : screenshots.landingPages;
      const sArr = Object.keys(ssData).map(s => {
        const ss = ssData[s];
        ss.key = s;
        return ss;
      });
      sArr.sort((a, b) => (a.domain > b.domain ? 1 : -1));
      const sortedScreenShotsData = {};
      sArr.forEach(ss => {
        sortedScreenShotsData[ss.key] = ss;
      });
      screenshots.data = sortedScreenShotsData;
      return (
        <>
          <h1>{screenshots.term}</h1>
          {split ? (
            <>
              {screenshots.data && (
                <>
                  <a href={landingPage} target="_blank">
                    Split test URL
                  </a>
                  <Shots items={split} />
                </>
              )}
            </>
          ) : (
            <>
              <ImageList
                items={screenshots.data}
                id={screenshots.landingPages}
                ctime={ctime}
                getAllShots={this.getAllShots}
              />
              {!Object.keys(screenshots.data).length && (
                <p>Looks like we couldn't find anything here.</p>
              )}
            </>
          )}
        </>
      );
    }

    return <h1>Loading...</h1>;
  }
}

export default ScreenShots;
